// extracted by mini-css-extract-plugin
export default {"error":"Error_error__oi9Fw","slideIn":"Error_slideIn__gGmG6","error-icon":"Error_error-icon__KnFTC","error-message":"Error_error-message__ahBfT"};